module.exports = __webpack_public_path__ + "static/media/home-news-img1.14035e02.jpg";